import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, map, tap } from 'rxjs';
import { ContractorI } from 'src/app/interfaces/contractor.interface';
import { BackendResponse } from 'src/app/interfaces/response.interface';
import { handleError } from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TrainingService {
  constructor(private readonly http: HttpClient) { }

  private url = environment.url;
  private lideresSubject = new BehaviorSubject<any>(null);
  form$: Observable<any> = this.lideresSubject.asObservable();
  //! POSITIONS --------------------------------------------------------------------->
  insertPosition(position: any) {
    const direction = `${this.url}training-positions`;
    return this.http.post<any>(direction, position).pipe(
      catchError((error) => handleError(error)),
      map((data) => (data.result ? data.result : data))
    );
  }
  getPositions(params?: HttpParams) {
    const direction = `${this.url}training-positions`;
    return this.http.get<any>(direction, { params }).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }
  updatePosition(id: string, participant: any) {
    const direction = `${this.url}training-positions/${id}`;
    return this.http.put<any>(direction, participant).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }
  //! POSITIONS --------------------------------------------------------------------->

  //! CONTRACTOR -------------------------------------------------------------------->
  getContractor(params?: HttpParams) {
    const direction = `${this.url}contractors`;
    return this.http.get<any>(direction, { params }).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }
  //! CONTRACTOR -------------------------------------------------------------------->

  //! PDT --------------------------------------------------------------------------->
  insertPdtFunction(pdt: any) {
    const direction = `${this.url}training-pdt-functions`;
    return this.http.post<any>(direction, pdt).pipe(
      catchError((error) => handleError(error)),
      map((data) => (data.result ? data.result : data))
    );
  }
  getPdtFunctions(params?: HttpParams) {
    const direction = `${this.url}training-pdt-functions`;
    return this.http.get<any>(direction, { params }).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }
  updatePdtFunction(id: string, pdt: any) {
    const direction = `${this.url}training-pdt-functions/${id}`;
    return this.http.put<any>(direction, pdt).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }
  //! PDT --------------------------------------------------------------------------->

  //! PARTICIPANTS ------------------------------------------------------------------>
  insertParticipant(participant: any) {
    const direction = `${this.url}training-evaluated-person`;
    return this.http.post<any>(direction, participant).pipe(
      catchError((error) => handleError(error)),
      map((data) => (data.result ? data.result : data))
    );
  }

  getParticipants(params?: HttpParams) {
    const direction = `${this.url}training-evaluated-person`;
    return this.http.get<any>(direction, { params }).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }

  getPermisosVencidos(params?: HttpParams) {
    const direction = `${this.url}training-evaluated-person/reportes/vencidos`;
    return this.http.get<any>(direction, { params }).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }

  updateParticipant(id: string, participant: any) {
    const direction = `${this.url}training-evaluated-person/${id}`;
    return this.http.put<any>(direction, participant).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }
  //! PARTICIPANTS ------------------------------------------------------------------>

  //! CATEGORY ---------------------------------------------------------------------->
  insertCategory(category: any) {
    const direction = `${this.url}training-category`;
    return this.http.post<any>(direction, category).pipe(
      catchError((error) => handleError(error)),
      map((data) => (data.result ? data.result : data))
    );
  }

  getCategories(params?: HttpParams) {
    const direction = `${this.url}training-category`;
    return this.http.get<any>(direction, { params }).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }

  updateCategory(id: string, category: any) {
    const direction = `${this.url}training-category/${id}`;
    return this.http.put<any>(direction, category).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }
  //! CATEGORY ---------------------------------------------------------------------->

  //! TYPE -------------------------------------------------------------------------->
  insertFormType(training: any) {
    const direction = `${this.url}training-form-types`;
    return this.http.post<any>(direction, training).pipe(
      catchError((error) => handleError(error)),
      map((data) => (data.result ? data.result : data))
    );
  }

  getFormTypes(params?: HttpParams) {
    const direction = `${this.url}training-form-types`;
    return this.http.get<any>(direction, { params }).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }

  updateFormType(id: string, training: any) {
    const direction = `${this.url}training-form-types/${id}`;
    return this.http.put<any>(direction, training).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }
  //! TYPE -------------------------------------------------------------------------->

  //! FORMS ------------------------------------------------------------------------->
  insertForm(form: any) {
    const direction = `${this.url}training-forms`;
    return this.http.post<any>(direction, form).pipe(
      catchError((error) => handleError(error)),
      map((data) => (data.result ? data.result : data))
    );
  }

  getForms(params?: HttpParams) {
    const direction = `${this.url}training-forms`;
    return this.http.get<any>(direction, { params }).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }

  getForm(id: string) {
    const direction = `${this.url}training-forms/${id}`;
    return this.http.get<any>(direction).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }

  updateForm(id: string, form: any) {
    const direction = `${this.url}training-forms/${id}`;
    return this.http.put<any>(direction, form).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }

  getLink(participant: any, form: any) {
    const direction = `${this.url}training-forms/participant/links/individual`;
    return this.http.post<any>(direction, {
      participants: participant,
      form: form,
    });
  }

  sendInvitation(body: any) {
    const direction = `${this.url}training-forms/participant/send-invitation`;
    return this.http
      .post(direction, body)
      .pipe(catchError((e) => handleError(e)));
  }
  //! FORMS ------------------------------------------------------------------------->

  //! EVALUATION -------------------------------------------------------------------->
  getEvaluation(user_id: string, form_id: string) {
    let params = new HttpParams();
    params = params.set('user_id', user_id);
    params = params.set('form_id', form_id);
    const direction = `${this.url}training-forms/participant/get-evaluation`;
    return this.http.get<any>(direction, { params }).pipe(
      map((data) => data.result),
      catchError((e) => handleError(e))
    );
  }

  submitEvaluation(body: {
    form_id: string;
    user_id: string;
    questions: any;
    ended: boolean;
  }) {
    const direction = `${this.url}training-forms/participant/submit-evaluation`;
    return this.http.post<any>(direction, body).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.score)
    );
  }

  getEvaluationView(id: string) {
    const direction = `${this.url}training-evaluation/${id}`;
    return this.http.get<any>(direction).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result)
    );
  }
  //! EVALUATION -------------------------------------------------------------------->
  // Datos Grafico Dashboard

  getFormDashboard(params: HttpParams): Observable<any> {
    let direction = `${this.url}training-forms/reportes/info`;
    return this.http.get<any>(direction, { params }).pipe(
      catchError((error) => handleError(error)),
      tap((data) => (this.lideresSubject = data.result.entities))
    );
  }

  getOneEvaluado(id: any): Observable<any> {
    let direction = `${this.url}training-evaluated-person/${id}`;
    return this.http.get<any>(direction).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }

  addFiles(form: any) {
    const direction = `${this.url}attachments`;
    return this.http.post<BackendResponse>(direction, form).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as any)
    );
  }
  addFilesNew(form: any) {
    const direction = `${this.url}attachments/newAttach`;
    return this.http.post<BackendResponse>(direction, form).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as any)
    );
  }

  // public addFilesNew(type: any | undefined): Observable<any> {
  //   let direction = this.url + 'attachments/newImages';
  //   return this.http
  //     .post<any>(direction, type)
  //     .pipe(catchError((error) => handleError(error)));
  // }



  removeFiles(id: number, form: any) {
    const direction = `${this.url}attachments/${id}`;
    return this.http.put<BackendResponse>(direction, form).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as any)
    );
  }

  getContractors() {
    const direction = this.url + 'contractors/contractor/participants';
    return this.http.get<BackendResponse>(direction).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as ContractorI[])
    );
  }

  getReporteCompetencias(params: HttpParams) {
    const direction =
      this.url + 'training-evaluated-person/reporte/competencias';
    return this.http.get<BackendResponse>(direction, { params }).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as any)
    );
  }


  enviarEmail(body: any) {
    const direction = `${this.url}training-evaluated-person/enviarEmails`;
    return this.http
      .post(direction, body)
      .pipe(catchError((e) => handleError(e)));
  }


  updateEvalucion(id: string, form: any) {
    const direction = `${this.url}training-evaluation/${id}`;
    return this.http.put<any>(direction, form).pipe(
      catchError((error) => handleError(error)),
      map((data) => data.result)
    );
  }
}
